// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__NZY4O","title":"styles_title__JcQ8_","content":"styles_content__P_r8Y"};